

; (function($) {

	$.extend($.fn, { AddHelpContext: function(helpContext, parentHelpContext) {
		var html = '<a class="ui-dialog-titlebar-help ui-corner-all" style="-moz-user-select: none;"';
		html += ' href="' + $.currentSitePath + 'Help.aspx/HelpFromContext?helpContext=';
		html += escape(helpContext);
		html += '&stratum=Dialog&parentHelpContext=';
		html += escape(parentHelpContext);
		html += '" target="PortalHelp"><span class="ui-icon ui-icon-help2" unselectable="on" style="-moz-user-select: none;">help</span></a>';

		$(this).parent().find(".ui-dialog-titlebar").append(html);
	}, getContainingDialog: function() {
	        return $(this).parents('.ui-dialog-content:first').data('dialogData');
	    }
	});
})(jQuery);

$.extend($, {

  logDetailDialog: function (linkObj, id, title) {
    var buttons = {};
    buttons[$.dictionary.getValue("closeButton")] = function() {
      dialog.closeDialog();
    };
    var data = $(linkObj).closest('table').getRowData(id);
    data.id = id;
    var logDetailsAction = $.currentSitePath + "Home.aspx/LogDetails";
    var dialog = $.genericDialog({
      dialogUrl: logDetailsAction,
      postData: data,
      width:675,
      title: title,
      buttons: buttons
    });
  },
  genericDialog: function (options) {
      ///<summary>Generic AQD Dialog</summary>
      /// <param name="options">
      /// --- showSpinner: Shows the loading spinner while the dialog loads
      /// --- dialogUrl: The URL to retrieve the dialog HTML from.
      /// --- dialogDiv: Alternatively, specify an existing DIV element.
      /// --- title: The title of the dialog.
      /// --- width: The width of the dialog in pixels
      /// --- height: The height of the dialog in pixels
      /// --- callback: The function to call when the user clicks the OK/Save button
    /// --- callback: The function to call when the user clicks the OK/Save button
      /// --- buttons: A set of custom buttons in the {"text":function()} format to use
      /// --- okButtonLabel: if custom buttons are not defined, use this label for the ok button
      /// --- closeButtonLabel: if custom buttons are not defined, use this label for the close button
      /// --- showSpinner: Shows the loading spinner - defaults to false
      /// </param>
      /* 
    options: {
    dialogUrl: "",
    title: "",
    width: "",
    height: "",
    callback: function() { },
    onError: function() { }}
    }
    */
      if (options.showSpinner != undefined && options.showSpinner === true)
          $.showLoadingSpinner();
    if (options.buttons != undefined && typeof options.buttons == "object") {
      options.setButtons = options.buttons;
      options.buttons = function (updateButtons) { updateButtons(options.setButtons); };
    }
    var returnedData = {
        options: options,
        center: function() {
          returnedData.dialogDiv.dialog('widget').position({ my: "center", at: "center", of: window });
        },
        addButton: function (buttonLabel, buttonCallback) {
            var buttons = returnedData.dialogDiv.dialog('option', 'buttons');
            buttons[buttonLabel] = buttonCallback;


            returnedData.dialogDiv.dialog('option', 'buttons', buttons);

        }, removeButton: function (buttonLabel) {
            var buttons = returnedData.dialogDiv.dialog('option', 'buttons');
            delete buttons[buttonLabel];


            returnedData.dialogDiv.dialog('option', 'buttons', buttons);

        },
        refreshButtons: function () {
            // Trigger options.buttons function again and refresh the buttons
            options.buttons(function(btns) {
                returnedData.dialogDiv.dialog('option', 'buttons', btns);
            });

        },
      callback: options.callback,
      dialogDiv: options.dialogDiv || $('<div></div>'),
      destroyOnClose: options.dialogDiv == undefined || options.dialogDiv == null,
      closeDialog: function () {
          if (returnedData.dialogDiv.length == 0)
              return;
          if (!$(returnedData.dialogDiv).hasClass('ui-dialog-content'))
              return;
          $(returnedData.dialogDiv).dialog("close");
        
        if (returnedData.destroyOnClose) {
          $(returnedData.dialogDiv).dialog("destroy");

          returnedData.dialogDiv.remove();
        }

        $('#actionCloseText').val("");
        $('#actionReopenText').val("");
        $('#actionDeleteText').val("");
      },
      updateButtons: function (buttons) {
        returnedData.dialogDiv.dialog('option', 'buttons', buttons);
      },
      showDialog: function () {

        options.buttons(function (btns) {

          returnedData.dialogDiv.dialog({
            autoOpen: false,
            title: options.title,
            closeOnEscape: false,
            width: options.width,
            minWidth: options.width || 530,
            maxWidth: 780,
            buttons: btns,
            resizable: false,
            open: function () { if (options.onOpen) options.onOpen.apply(this, arguments); },
            modal: true,
            maxHeight: options.height || 380,
            position: ['centre', 85]
          });
          returnedData.dialogDiv.dialog("open");
            returnedData.dialogDiv.dialog('widget').position({ my: "center", at: "center", of: window });
          if (options.helpGuid != undefined) {
            returnedData.dialogDiv.parent().find(".ui-dialog-titlebar .ui-dialog-titlebar-help").remove();
            returnedData.dialogDiv.AddHelpContext(options.helpGuid, options.parentHelpGuid);
          }
          if (options.showSpinner != undefined && options.showSpinner == true)
              $.hideLoadingSpinner();
        });
      }
    };
    
    if (options.okButtonLabel == undefined )
        options.okButtonLabel = options.saveButton ?  $.dictionary.getValue("saveButton") : $.dictionary.getValue("okButton");
    if (options.buttons == undefined) {
      options.buttons = function (setButtons) {
        var lbuttons = {};
        lbuttons[options.closeButtonLabel || $.dictionary.getValue("cancelButton")] = function () { returnedData.closeDialog(); };
        lbuttons[options.okButtonLabel] = function () { returnedData.callback(returnedData, returnedData.data); };
        setButtons(lbuttons);
      };
    }
    returnedData.dialogDiv.data('dialogData', returnedData);
    returnedData.dialogDiv.bind('submitDialog', function () { returnedData.callback(returnedData, returnedData.data); });
    returnedData.dialogDiv.bind('closeDialog', function () { returnedData.closeDialog(); });


    //call the controller for the data
    if (options.dialogUrl != undefined) {
      var ajaxMethod = $.get;
      if (options.postData)
        ajaxMethod = $.post;
      ajaxMethod(options.dialogUrl, (options.postData || {}), function (data) {
        if (typeof data === "object") {

          $(returnedData.dialogDiv).remove();
          $.hideLoadingSpinner();
          return;
        }
        returnedData.dialogDiv.html(data);

        returnedData.showDialog();
        if (options.center) {
          window.setTimeout(function() { returnedData.center() }, 500);
          window.setTimeout(function () { returnedData.center() }, 550);
          window.setTimeout(function () { returnedData.center() }, 600);
        }
      });
    } else {
      returnedData.showDialog();
      if (options.center) {
        window.setTimeout(function () { returnedData.center() }, 500);
        window.setTimeout(function () { returnedData.center() }, 550);
        window.setTimeout(function () { returnedData.center() }, 600);
      }
    }




    
    return returnedData;
  },
	editSignatureDialog: function (editSignatureUrl) {
		var signatureDiv = $("<div></div>");
		var dbuttons = {};
    dbuttons[$.dictionary.getValue("cancelButton")] = function () { $(this).dialog("close"); $(this).dialog("destroy"); signatureDiv.remove(); };
		dbuttons[$.dictionary.getValue("okButton")] = function () { return saveSignature(); };
		signatureDiv.load(editSignatureUrl);
		signatureDiv.dialog({
			autoOpen: false,
			title: $.dictionary.getValue("buttonLabel_EditSignature"),
			closeOnEscape: false,
      width: 510,
      height: 172,
			position: ['centre', 50],
			buttons: dbuttons
		});
		signatureDiv.dialog("open");
		var saveSignature = function () {

			var url = signatureDiv.find('form').attr('action');
			var data = signatureDiv.find('form').serializeArray();
      if (data[0].value.length > 255) {
        $.errorDialog($.dictionary.getValue("error_StringRange").replace("{0}", "0").replace("{1}", 255));
        return false;
      }
			jQuery.post(url, data, function (result) {
				$(signatureDiv).trigger("OnSaveSignature", { result: result, data: data });
				$(this).dialog("close");
				$(this).dialog("destroy");
				signatureDiv.remove();
			});

		};
		signatureDiv.AddHelpContext('{3BC51D3A-413F-414E-8C7B-8151860B3FC4}', '{0A31B4F6-5740-4CAE-BC2C-4CF0B204591A}');
	},
	addressBookDialog: function (addressBookUrl, options) {
    var defaultOptions = { showRole: true, filterText: "", addressBook: '', showBccInput: false, addressButtonLabel: null, showCcInput:true, showAddressBooks: false, showToCcInputs: false, showFilterInput: false, onSubmit: function () { }, addressBookTitle: $.dictionary.getValue("Title_AddressBook"), selectButtonLabel: $.dictionary.getValue("buttonLabel_Select"), cancelButtonLabel: $.dictionary.getValue("buttonLabel_Cancel"), showAllButtonLabel: $.dictionary.getValue("buttonLabel_ShowAll") };
		if (options == undefined)
			options = {};
		options = $.extend(defaultOptions, options);
    if (options.callback == undefined)
      options.callback = function () { };
		if (options.consolidate == undefined)
			options.consolidate = options.addressBook == '' && options.showAddressBooks == false;
		var selectBtn = "Select";
		var cancelBtn = "Cancel";
		var showAllBtn = "Show All";
		var dbuttons = {};
    if (options.cancelButtonLabel)
      cancelBtn = options.cancelButtonLabel;
		if (options.selectButtonLabel)
			selectBtn = options.selectButtonLabel;
		if (options.showAllButtonLabel)
			showAllBtn = options.showAllButtonLabel;
		var addressBookDiv = $('<div></div');
    dbuttons[cancelBtn] = function () { $(this).dialog("close"); $(this).dialog("destroy"); addressBookDiv.remove(); };
		dbuttons[selectBtn] = function () { return selectAddress(); };
		dbuttons[showAllBtn] = function () { showAll(); };
		var url = $.buildUrl(addressBookUrl,
		{
      consolidate: options.consolidate, initialAddressBook: options.addressBook, showAddressBookList: options.showAddressBooks, showRole: options.showRole,
      showTextbox: options.showFilterInput, showToCcPanel: options.showToCcInputs, showCcPanel: options.showCcInput, showBccPanel: options.showBccInput, filter: options.filterText,
      addressButtonLabel: options.addressButtonLabel
		});
    addressBookDiv.load(url, {}, options.callback);
		addressBookDiv.dialog({
      autoOpen: false,
      modal:true,
			title: options.addressBookTitle,
      closeOnEscape: false,
      autoResize:true,
			width: 700,
      position: {
        my: "center",
        at: "center",
        of: window
      },
      resize: function() {
        addressBookDiv.parent().position({ my: "center", at: "center", of: window });
      },
			buttons: dbuttons
    });
    addressBookDiv.dialog("open");
	  $(document).on('ajaxStop',
	    function() {
        addressBookDiv.parent().position({ my: "center", at: "center", of: window });

	    });
	//  addressBookDiv.parent().position({ my: "center", at: "center", of: window });
		var showAll = function () {
			$(addressBookDiv).trigger("ShowAll");
		};
		var selectAddress = function () {
			var evt = $.Event('ClickSelect');
			$(addressBookDiv).trigger(evt);
			var selectedAddressResult = evt.result;

			options.onSubmit(selectedAddressResult);
			$.genericPortalCloseDialog(addressBookDiv, addressBookDiv, false);
		};
		addressBookDiv.AddHelpContext('{68580244-FADE-499E-86F7-EAF10951A281}', '{0A31B4F6-5740-4CAE-BC2C-4CF0B204591A}');
	},
	sendEmailDialog: function (emailActionUrl, options) {
		var defaultOptions = { sendEmailLabel: $.dictionary.getValue("buttonLabel_Send"), cancelLabel: $.dictionary.getValue("buttonLabel_Cancel"), checkNamesLabel: $.dictionary.getValue("buttonLabel_CheckNames"), editSignatureLabel: $.dictionary.getValue("buttonLabel_EditSignature"), showCheckNames: true, showEditSignature: true, editSignatureUrl: $.buildUrl("/Home.aspx/EditEmailSignature"), title: $.dictionary.getValue('Title_SendEmail') };
		if (options == undefined)
			options = {};
		options = $.extend(defaultOptions, options);
		var sendBtn = "Send";
		var cancelBtn = "Cancel"; var dbuttons = {};
		if (options.sendLabel)
			sendBtn = options.sendLabel;
		if (options.cancelLabel)
			cancelBtn = options.cancelLabel;
		var emailDiv = $('<div></div');
		dbuttons[options.sendEmailLabel] = function () { return submitEmail(); };
		dbuttons[options.cancelLabel] = function () { $(this).dialog("close"); $(this).dialog("destroy"); emailDiv.remove(); };
		if (options.showCheckNames) {
			dbuttons[options.checkNamesLabel] = function () { return checkNames(); };
		}
		if (options.showEditSignature) {
			dbuttons[options.editSignatureLabel] = function () { return editSignature(); };
		}
		emailDiv.load(emailActionUrl);
		emailDiv.dialog({
			autoOpen: false,
			title: options.title,
			closeOnEscape: false,
			width: 678,
			position: ['centre', 50],
			buttons: dbuttons
		});
		emailDiv.dialog("open");
		var editSignature = function () {
			$.editSignatureDialog(options.editSignatureUrl);
		};
		var checkNames = function () {
			emailDiv.trigger('CheckNames.Email');
		};
		var submitEmail = function () {
			var url = emailDiv.find('form').attr('action');
			var evt = $.Event('BeforeSendEmail');
			$(emailDiv).trigger(evt);
			if (evt.result != false) {
				// Serialize data and send
				var data = emailDiv.find('form').serializeArray();

				// Convert array to value JSON object

				jQuery.post(url, data, function (result) {
					$(emailDiv).trigger("AfterSendEmail", { data: data, result: result });
					$(this).dialog("close");
					$(this).dialog("destroy");
					emailDiv.remove();
				});
			}

		};
	},
	findStaffDialog: function (areaAspx, options, selected) {
		var diaWidth = 870;
		if (selected == undefined && options != undefined)
		    selected = options;
		if (options == "GroupSearch") {
			diaWidth = 500;
	        pathname = $.currentSitePath + "StaffSearch.aspx/GroupSearch?";
	    }
	    else if (options.checklist != undefined) {
	        pathname = $.currentSitePath + "StaffSearch.aspx/ChecklistSearch?" + options.checklisst;
	    } else {
		    pathname = $.currentSitePath + "StaffSearch.aspx/StaffSearch?";
	    }

	   
	    if (options.querystring != undefined)
			pathname = pathname + options.querystring;
		if (options.showInactive != undefined)
			pathname = pathname + "&showInactive=" + options.showInactive.toString();
		if (options.showInactiveCheckbox != undefined)
		    pathname = pathname + "&showInactiveCheckbox=" + options.showInactiveCheckbox.toString();
		pathname = pathname + "&areaAspx=" + areaAspx;
		if (options.dialogId != undefined)
		    pathname = pathname + "&dialogId=" + options.dialogId;
		if (options.checklist != undefined){
		//if ((options.indexOf("cl") >= 0)) {
		//    options = options.replace("cl", "");
	       pathname = pathname + "&options=" + options.checklist;
	    }
	    var buttonPath = $.currentSitePath
		if (options == "GroupSearch") {
	         buttonPath = buttonPath + "StaffSearch.aspx/GetGroupButtonsWithCulture";
	    } else {
	        buttonPath = buttonPath + "StaffSearch.aspx/GetButtonsWithCulture";
	    }
		
		//alert(pathname);;
		var titleTxt;
		var closeBtn;
		var selectBtn;

	    $.ajax({
	        type: "GET",
			url: buttonPath,
			dataType: "json",
			async: false,
			success: function (data) {
				titleTxt = data.title;
				selectBtn = data.submit;
				closeBtn = data.close;
			}
		});

		var dbuttons = {};

		dbuttons[closeBtn] = function () {
		    var theObj = this; $(theObj).dialog("close"); $(theObj).dialog("destroy"); staffDiv.remove();
		};
    dbuttons[selectBtn] = function () { returnStaffResults(this); };

		var staffDiv = $("<div></div>");
        $.get(pathname, {}, function (data) {
            staffDiv.html(data);
            staffDiv.dialog('widget').position({ my: "center", at: "center", of: window });
            staffDiv.find('table').bind('jqGridLoadComplete', function() {
                 staffDiv.dialog('widget').position({ my: "center", at: "center", of: window });
            });
        });

		//bind to the event we know is coming from the search control
		$(document).bind('closeStaffSearch', function () { returnStaffResults(); });
		
	    var opts = {
			autoOpen: false,
			title: titleTxt,
			closeOnEscape: false,
      width: diaWidth,
      position: { my: "center", at: "center", of: window },
      modal: true,
			buttons: dbuttons
		};
		staffDiv.dialog(opts).dialog("open");
		staffDiv.AddHelpContext('{A243D361-46D4-4f6b-86AF-8F29734EB49E}', '{141BACE2-102D-4B76-9913-9FFFA4628821}');

		returnStaffResults = function (theObj) {
	        var selId = $("#StaffSearchSelectedId").val();
	        
	        if (selId.length > 0) {
	            var selName = $("#StaffSearchSelectedName").val();
	            var selPosition = $("#StaffSearchSelectedPosition").val();
	            var result = { Id: selId, Name: selName, Position: selPosition };
	            selected(result);
	            //remember to unbind so we don't get multilpe listeners
	            $(document).unbind('closeStaffSearch');
	            $(theObj).dialog("close").dialog("destroy");
	            staffDiv.remove();
	        }
	    };
	}, findAircraftDialog: function (areaAspx, options, selected) {

	    if (selected == undefined && options != undefined)
	        selected = options;

	    pathname = $.currentSitePath + "Lookup.aspx/AircraftModelSearchDialog?";


	    if (options.querystring != undefined)
	        pathname = pathname + options.querystring;
	    if (options.showInactive != undefined)
	        pathname = pathname + "&showInactive=" + options.showInactive.toString();
	    pathname = pathname + "&areaAspx=" + areaAspx;
	    if (options.dialogId != undefined)
	        pathname = pathname + "&dialogId=" + options.dialogId;
	    var buttonPath = $.currentSitePath + "Lookup.aspx/AircraftModelSearchButtonsWithCulture";
	    //alert(pathname);;
	    var titleTxt;
	    var closeBtn;
	    var selectBtn;


	    $.ajax({
	        type: "GET",
	        url: buttonPath,
	        dataType: "json",
	        async: false,
	        success: function (data) {
	            titleTxt = data.title;
	            selectBtn = data.submit;
	            closeBtn = data.close;
	        }
	    });

	    var dbuttons = {};

	    dbuttons[closeBtn] = function () { $(this).dialog("close"); $(this).dialog("destroy"); aircraftModelDiv.remove(); };
	    dbuttons[selectBtn] = function () { returnAircraftResults(); };
	    var aircraftModelDiv = $("<div></div>").appendTo($(document.body));
	    $.get(pathname, {}, function (data) { aircraftModelDiv.html(data); });

	    //bind to the event we know is coming from the search control
	    $(document).bind('closeAircraftModelSearch', function () { returnAircraftResults(); });
	    aircraftModelDiv.dialog({
	        autoOpen: false,
	        title: titleTxt,
	        closeOnEscape: false,
	        width: 470,
	        close: function () { $(this).dialog('destroy').remove(); },
	        position: ['centre', 50],
	        modal: true,
	        buttons: dbuttons
	    });
	    aircraftModelDiv.dialog("open");
	    aircraftModelDiv.AddHelpContext('{35F51ED2-C9BD-4053-A21A-C2A470587190}', '{141bace2-102d-4b76-9913-9fffa4628821}');

	    returnAircraftResults = function (obj) {
	        var selId = $("#AircraftModelID").val();
	        if (selId.length > 0) {
	            var selName = $("#AircraftModelFriendlyName").val();

	            var result = { ID: selId, FriendlyName: selName, Manufacturer: $("#AircraftModelManufacturer").val(), Model: $("#AircraftModelModel").val(), AircraftClass: $("#AircraftModelClass").val() };
	            selected(result);
	            //remember to unbind so we don't get multilpe listeners
	            $(document).unbind('closeAircraftModelSearch');
	            $.genericPortalCloseDialog(obj, aircraftModelDiv, false);
	        }
	    }
	}, findDepartmentDialog: function (areaAspx, options, selected) {
	    if (selected == undefined && options != undefined)
	        selected = options;
	    pathname = $.currentSitePath + "DepartmentSearch.aspx/DepartmentSearch?";
	    if (options.querystring != undefined)
	        pathname = pathname + options.querystring;
	    if (options.url != undefined)
	        pathname = $.currentSitePath + options.url;
	    if (options.params != undefined)
	        pathname = $.extendUrl(pathname, options.params);
	    if (options.readOnly == undefined) 
	        options.readOnly = false;

	    if (options.readOnly != false)
	        pathname = $.extendUrl(pathname, { readonly: true });
	    var buttonPath = $.currentSitePath + "DepartmentSearch.aspx/GetButtonsWithCulture";

	    var titleTxt;
	    var closeBtn;
	    var selectBtn;

	    $.ajax({
	        type: "GET",
	        url: buttonPath,
	        dataType: "json",
	        async: false,
	        success: function (data) {
	            titleTxt = data.title;
	            selectBtn = data.submit;
				closeBtn = data.close;
		        
	        }
	    });



	    var dbuttons = {};
	    dbuttons[closeBtn] = function () { $(this).dialog("close"); $(this).dialog("destroy"); departmentDiv.remove(); };
        if (!options.readOnly)
	    dbuttons[selectBtn] = function () { returnDepartmentResults(this); };

	    var departmentDiv = $("<div></div>").appendTo($(document.body));
	    $.get(pathname, {}, function(data) {
	        departmentDiv.html(data); 
            departmentDiv.dialog('widget').position({ my: "center", at: "center", of: window });
            departmentDiv.find('table').bind('jqGridLoadComplete', function () {
                departmentDiv.dialog('widget').position({ my: "center", at: "center", of: window });
            });
	    });

	    //bind to the event we know is coming from the search control
	    $(document).bind('closeDepartmentSearch', function () { returnDepartmentResults(); });
	    if (options.selectedId != undefined && options.selectedId != null) {
	        $(document).bind('DepartmentGridLoaded', function (ev, d) {
	            $("#DepartmentSearchSelectedId").val(options.selectedId);
	            $(d).setSelection(options.selectedId);
	        });
	    }

	    departmentDiv.dialog({
	        autoOpen: false,
	        title: titleTxt,
	        closeOnEscape: false,
			width: 475,
	        maxHeight: 600,
            position: { my: "center", at: "center", of: window },
	        modal: true,
	        buttons: dbuttons
	    });
	    departmentDiv.dialog("open");
	    departmentDiv.AddHelpContext('{2C3D0476-2679-418A-A4EB-48D6C4334D1E}', '{141bace2-102d-4b76-9913-9fffa4628821}');

	    returnDepartmentResults = function () {
	        var selId = $("#DepartmentSearchSelectedId").val();
	        if (selId.length > 0) {
	            var selName = $("#DepartmentSearchSelectedName").val();

	            var result = { ID: selId, Name: selName };
	            selected(result);
	            //remember to unbind so we don't get multilpe listeners
	            $(document).unbind('closeDepartmentSearch');
	            departmentDiv.dialog("close");
	            departmentDiv.dialog("destroy");
	            departmentDiv.remove();
	        }
	    }
	},
  
	findDescriptorDialog: function (url, options, selected) {
	    if (selected == undefined && options != undefined) {
	        selected = options;
	        options = {};
	    }
	    if (options.parent_id != undefined && options.parent_id == 0)
	        options.parent_id = null;

	    var titleTxt;
	    var closeBtn;
	    var selectBtn;

	    

	    var dbuttons = {};
	    dbuttons[$.dictionary.getValue('closeButton')] = function () { $(this).dialog("close"); $(this).dialog("destroy"); descriptorDiv.remove(); };
	    dbuttons[$.dictionary.getValue('selectButton')] = function () { returnDescriptorResults(this); };

	    var descriptorDiv = $("<div></div>").appendTo($(document.body));
	    
	    $.get(url, options, function (data) { descriptorDiv.html(data); });

	    //bind to the event we know is coming from the search control
	    $(document).bind('closeDescriptorSearch', function () { returnDescriptorResults(); });
	    descriptorDiv.dialog({
	        autoOpen: false,
	        title: options.title || "Title",
	        closeOnEscape: false,
	        width: 470,

	        position: ['center', 50],
	        modal: true,
	        buttons: dbuttons
	    });
	    descriptorDiv.dialog("open");
	    descriptorDiv.AddHelpContext('{44594CCF-4B0B-42A0-91B7-D11E1BB09608}', '{141bace2-102d-4b76-9913-9fffa4628821}');
	    $.findDescriptorDialog.selectedValue = null;
	    returnDescriptorResults = function() {
	        
	        if ($.findDescriptorDialog.selectedValue != null) {
	            
	            selected($.findDescriptorDialog.selectedValue);
	            //remember to unbind so we don't get multilpe listeners
	            $(document).unbind('closeDescriptorSearch');
	            descriptorDiv.dialog("close").dialog("destroy");
	            descriptorDiv.remove();
	        }
	    };
	},

  findLocationDialog: function (areaAspx, options, selected) {
    if (selected == undefined && options != undefined)
      selected = options;
    pathname = $.currentSitePath + "LocationSearch.aspx/LocationSearch?";
    if (options.querystring != undefined)
      pathname = pathname + options.querystring;
    if (options.url != undefined)
      pathname = $.currentSitePath + options.url;
    if (options.params != undefined)
      pathname = $.extendUrl(pathname, options.params);
    var buttonPath = $.currentSitePath + "LocationSearch.aspx/GetButtonsWithCulture";

    var titleTxt;
    var closeBtn;
    var selectBtn;

    $.ajax({ type: "GET",
      url: buttonPath,
      dataType: "json",
      async: false,
      success: function (data) {
        titleTxt = data.title;
        selectBtn = data.submit;
        closeBtn = data.close;
      }
    });

    var dbuttons = {};

    dbuttons[closeBtn] = function () { $(this).dialog("close"); $(this).dialog("destroy"); locationDiv.remove(); };
    dbuttons[selectBtn] = function () { returnLocationResults(); };
    var locationDiv = $("<div></div>").appendTo($(document.body));
    $.get(pathname, {}, function (data) { locationDiv.html(data); });

    //bind to the event we know is coming from the search control
    $(document).bind('closeLocationSearch', function () { returnLocationResults(); });
    locationDiv.dialog({
      autoOpen: false,
      title: titleTxt,
      closeOnEscape: false,
      width: 470,
      close: function () { $(this).dialog('destroy').remove(); },
      position: ['centre', 50],
      modal: true,
      buttons: dbuttons
    });
    locationDiv.dialog("open");
    locationDiv.AddHelpContext('{35F51ED2-C9BD-4053-A21A-C2A470587190}', '{141bace2-102d-4b76-9913-9fffa4628821}');

    returnLocationResults = function (obj) {
      var selId = $("#LocationSearchSelectedId").val();
      if (selId.length > 0) {
          var selName = $("#LocationSearchSelectedName").val();
          var selType = $("#LocationSearchSelectedType").val();

        var result = { ID: selId, Name: selName, Type: selType };
        selected(result);
        //remember to unbind so we don't get multilpe listeners
        $(document).unbind('closeLocationSearch');
        $.genericPortalCloseDialog(obj, locationDiv, false);
		}
    }
	},



	membershipDialog: function (areaAspx, assignedList, unassignedList,
														 assignedArgs, unassignedArgs, title, isReadOnly, withFilter, result, helpcontex, parenthelpcontext) {
		var defaultSettings = {
			url: "/Membership.aspx/ListEdit"
		};
		var pathname = $.buildUrl(defaultSettings["url"]);
		var buttonPath = $.buildUrl("/Membership.aspx/GetButtonsWithCulture");

		var listDiv = $("<div></div>");

		var cancelBtn;
		var closeBtn;
		var saveBtn;

		$.ajax({ type: "GET",
			url: buttonPath,
			dataType: "json", 
			async: false,
			success: function (data) {
				cancelBtn = data.cancel;
				saveBtn = data.save;
				closeBtn = data.close;
			}
		});
		$.get(pathname, { fullListQueryName: assignedList, assignedListQueryName: unassignedList,
			fullListArgs: unassignedArgs, assignedListArgs: assignedArgs,
			isReadOnly: isReadOnly, withFilter: withFilter, inactive: "false"
		}, function (data) { listDiv.html(data); });

		if (isReadOnly == "False") {
			var buttons = {};

      buttons[cancelBtn] = function () {
        $(this).dialog("close");
        $(this).dialog("destroy");
        listDiv.remove();
      };

			buttons[saveBtn] = function () {
				$("#AssignedList *").attr("selected", "selected");
				$("#UnassignedList *").attr("selected", "selected");
				var asslistbox = $("#AssignedList");
				var unasslistbox = $("#UnassignedList");
				var assignedList = asslistbox.val();
				var unassignedList = unasslistbox.val();
				var resultLists = { Assigned: assignedList, Unassigned: unassignedList };

				result(resultLists);
				$(this).dialog("close");
				$(this).dialog("destroy");
				listDiv.remove();
			};

			listDiv.dialog({
				autoOpen: false,
				title: title,
				closeOnEscape: false,
        width: 700,
				buttons: buttons
			});
		}
		else {
			var buttons = {};
			buttons[closeBtn] = function () {
				$(this).dialog("close");
				$(this).dialog("destroy");
				listDiv.remove();
			};
			listDiv.dialog({
				autoOpen: false,
				title: title,
				closeOnEscape: false,
        width: 700,
				buttons: buttons
			});
		}

		listDiv.dialog("open");
		listDiv.AddHelpContext(helpcontex, parenthelpcontext);
	},

	newmembershipDialog: function (formType, assignedList, unassignedList,
														    assignedArgs, unassignedArgs,
                                title, isReadOnly, withFilter,
                                result, helpcontex, parenthelpcontext) {
	  var defaultSettings = {
	    url: "/Membership.aspx/ListEdit"
	  };
	  var pathname = $.buildUrl(defaultSettings["url"]);
	  var buttonPath = $.buildUrl("/Membership.aspx/GetButtonsWithCulture");

	  var listDiv = $("<div></div>");

	  var cancelBtn;
	  var closeBtn;
	  var saveBtn;

	  $.ajax({
	    type: "GET",
	    url: buttonPath,
	    dataType: "json",
	    async: false,
	    success: function (data) {
	      cancelBtn = data.cancel;
	      saveBtn = data.save;
	      closeBtn = data.close;
	    }
	  });
	  $.get(pathname, {
	    fullListQueryName: assignedList, assignedListQueryName: unassignedList,
	    fullListArgs: unassignedArgs, assignedListArgs: assignedArgs,
	    isReadOnly: isReadOnly, withFilter: withFilter, inactive: "false", qFormType: formType
	  }, function (data) { listDiv.html(data); });

	  if (isReadOnly == "False") {
	    var buttons = {};

	    buttons[cancelBtn] = function () {
	      $(this).dialog("close");
	      $(this).dialog("destroy");
	      listDiv.remove();
	    };

	    buttons[saveBtn] = function () {
	      $("#AssignedList *").attr("selected", "selected");
	      $("#UnassignedList *").attr("selected", "selected");
	      var asslistbox = $("#AssignedList");
	      var unasslistbox = $("#UnassignedList");
	      var assignedList = asslistbox.val();
	      var unassignedList = unasslistbox.val();
	      var resultLists = { Assigned: assignedList, Unassigned: unassignedList };

	      result(resultLists);
	      $(this).dialog("close");
	      $(this).dialog("destroy");
	      listDiv.remove();
	    };

	    listDiv.dialog({
	      autoOpen: false,
	      title: title,
	      closeOnEscape: false,
	      width: 700,
	      buttons: buttons
	    });
	  }
	  else {
	    var buttons = {};
	    buttons[closeBtn] = function () {
	      $(this).dialog("close");
	      $(this).dialog("destroy");
	      listDiv.remove();
	    };
	    listDiv.dialog({
	      autoOpen: false,
	      title: title,
	      closeOnEscape: false,
	      width: 700,
	      buttons: buttons
	    });
	  }

	  listDiv.dialog("open");
	  listDiv.AddHelpContext(helpcontex, parenthelpcontext);
	},

  membershipRoleDialog: function (groupId, buttons, header, helpcontex, parenthelpcontext, callback) {
    var isDirty = '0';
    var origData = "";
    var defaultSettings = {
      getUrl: "/Membership.aspx/CopyRole?groupId=" + groupId

    };
    $('#memGroupDiv').remove();
    var groupDiv = $("<div id='memGroupDiv'></div>");
    var getpathname = $.buildUrl(defaultSettings["getUrl"]);
    var buttonPath = $.buildUrl("/Membership.aspx/GetButtonsWithCulture");

    //adds buttons to the dialog at runtime
    addButtons = function() {

      var fdialog = groupDiv.find(".ui-dialog-content");
      var buttons = getButtons(this);
      groupDiv.dialog('option', 'buttons', buttons);

    };

    //returns an array of buttons
    getButtons = function () {
      var dbuttons = {};
      dbuttons[cancelmBtn] = function () { closeRole(); if (callback != undefined) { callback(); } };
      dbuttons[savemBtn] = function () {
        saveRole(false);
        isDirty = 0;
        //addButtons();
        //if (callback != undefined) { callback(); }
      };

      return dbuttons;
    };

    //function to display the returned data
    setdata = function (data) {

      origData = data;
      $('.ui-dialog textarea').val(data);
      //bind to change events of all inputs
      var isDirtyCheck = function () {
          
        isDirty = '1';
        //addButtons();
        $(".ui-dialog input, .ui-dialog textarea").unbind('change.isDirty').unbind('keypress.isDirty');
      };
      $(".ui-dialog input, .ui-dialog textarea").bind('change.isDirty', isDirtyCheck);
    },

    //close the sucker down
    closeRole = function () {
      var theDiv = $("#memGroupDiv");
      
      doClose = function () {
        $(theDiv).dialog("close");
        $(theDiv).remove();
      };
      doClose();
    },

    //saves the state change to the work request
    saveRole = function () {
      SaveGroupRole(function(securityGroupId) {
        closeRole();
        if (callback != undefined) { callback(securityGroupId); }
      });
    },

    //resets the form data to the original
    resetForm = function () {
      setdata(origData);
      isDirty = 0;
      addButtons();
    }


    var openDialog = function () {
      var btns = getButtons();
      //open the dialog
      groupDiv.dialog({
        autoOpen: false,
        title: header,
        closeOnEscape: false,
        width: 420,
        close: function() {
          $(this).dialog('destroy').remove();
        },
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 280,
        position: { my: "center", at: "center", of: window }
      });
      groupDiv.load(
        getpathname,
        function() {
          console.debug('groupDiv load');
          setdata('');
        });

    };

    //here is the actual processing
    //gets the button txts
    $.ajax({ type: "GET",
      url: buttonPath,
      dataType: "json",
      async: false,
      success: function (data) {
        savemBtn = data.save;
        closeBtn = data.close;
        titleTxt = data.titleChangeLog;
        selectBtn = data.submit;
        cancelmBtn = data.cancel;
        openDialog();
      }
    });

    groupDiv.AddHelpContext(helpcontex, parenthelpcontext);
    groupDiv.dialog("open");
  },



  confirmDialog: function (message, title, confirmed, cancel) {
      var confirm = $("<div></div>");
      confirm.html("<div class='dialogConfirm'>" + message + "</div>");
      var buttons = {};

      buttons[$.dictionary.getValue('noButton')] = function () { $(this).dialog('close'); $(this).dialog('destroy'); $(this).remove(); if (cancel) { cancel(); } };
      buttons[$.dictionary.getValue('yesButton')] = function () { if (confirmed) { $(this).dialog('close'); $(this).dialog('destroy'); $(this).remove(); confirmed(); } };

      confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons, stack: false });
  },
  confirmDialogModal: function (message, title, confirmed, cancel) {
      var confirm = $("<div></div>");
      confirm.html("<div class='dialogConfirm'>" + message + "</div>");
      var buttons = {};

      buttons[$.dictionary.getValue('noButton')] = function () { $(this).dialog('close'); $(this).dialog('destroy'); $(this).remove(); if (cancel) { cancel(); } };
      buttons[$.dictionary.getValue('yesButton')] = function () { if (confirmed) { $(this).dialog('close'); $(this).dialog('destroy'); $(this).remove(); confirmed(); } };

      confirm.dialog({ modal:true, dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons, stack: false });
  },
	customDialog: function (message, title, buttons) {
		var confirm = $("<div></div>");
		confirm.html("<div class='dialogConfirm'>" + message + "</div>");
		confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons });
		return confirm;
	},
	customDialogNoWarn: function (message, title, buttons) {
	  var confirm = $("<div></div>");
	  confirm.html("<div class='dialogConfirmNoWarning'>" + message + "</div>");
	  confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons });
	  return confirm;
	},
	yesNoDialog: function (message, title, yesFunction, noFunction) {
	  var yn = $("<div></div>");
	  yn.html("<div class='dialogYesNoCancel'>" + message + "</div>");
	  var buttons = {};
	  buttons[$.dictionary.getValue('noButton')] = function () { if (noFunction) { noFunction(); } $(this).dialog('destroy'); };
	  buttons[$.dictionary.getValue('yesButton')] = function () { if (yesFunction) { yesFunction(); } $(this).dialog('destroy'); };

	  yn.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons });
	},
	yesNoCancelDialog: function (message, title, yesFunction, noFunction, cancelFunction) {
		var ync = $("<div></div>");
		ync.html("<div class='dialogYesNoCancel'>" + message + "</div>");
		var buttons = {};
		buttons[$.dictionary.getValue('cancelButton')] = function () { if (cancelFunction) { cancelFunction(); } $(this).dialog('destroy'); };
		buttons[$.dictionary.getValue('noButton')] = function () { if (noFunction) { noFunction(); } $(this).dialog('destroy'); };
		buttons[$.dictionary.getValue('yesButton')] = function () { if (yesFunction) { yesFunction(); } $(this).dialog('destroy'); };

		ync.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons });
	},
	infoDialog: function (message, title, callback) {
		var confirm = $("<div></div>");
		confirm.html("<div class='dialogInfo'>" + message + "</div>");
		var buttons = {};
		buttons[$.dictionary.getValue('okButton')] = function () {
	        $(this).dialog('close'); $(this).dialog('destroy'); if (callback != undefined) { callback(); }
	    };
		confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons, stack: false });
	},
	infoDialogModal: function (message, title, callback) {
		var confirm = $("<div></div>");
		confirm.html("<div class='dialogInfo'>" + message + "</div>");
		var buttons = {};
		buttons[$.dictionary.getValue('okButton')] = function () {
		    $(this).dialog('close'); $(this).dialog('destroy'); if (callback != undefined) { callback(); } };
		confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons, stack: false, modal: true });
	},
	errorDialog: function (message, title, callback) {
    if (title == undefined || title == "")
      title = $.dictionary.getValue('error'); 
		var confirm = $("<div></div>");
		confirm.html("<div class='dialogError'>" + message.replace(/\n/gi, "<br/>") + "</div>");
		var buttons = {};
    buttons[$.dictionary.getValue('okButton')] = function () { $(this).dialog('destroy'); if (callback != undefined) { callback(); } };
	    confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons });
    return confirm;
	}, errorDialogModal: function (message, title, callback) {
	    if (title == undefined || title == "")
	        title = $.dictionary.getValue('error');
	    var confirm = $("<div></div>");
	    confirm.html("<div class='dialogError'>" + message.replace(/\n/gi, "<br/>") + "</div>");
	    var buttons = {};
	    buttons[$.dictionary.getValue('okButton')] = function () { $(this).dialog('destroy'); if (callback != undefined) { callback(); } };
	    confirm.dialog({ dialogClass: "message-dialog", width: 460, title: title, "buttons": buttons, modal:true });
    return confirm;
	},
	errorDetailDialog: function (message, title, detail, callback) {

		var confirm = $("<div></div>");
		confirm.html("<div class='dialogError'>" + message.replace(/\n/gi, "<br/>") + "</div>");
		var buttons = {};

		buttons[$.dictionary.getValue('okButton')] = function () { $(this).dialog('destroy'); if (callback) callback(); };
		buttons[$.dictionary.getValue('moreDetailButton')] = function () {
			if (this.detail != undefined) {
				if ($(this.detail).is(':visible'))
					$(this.detail).hide();
				else
					$(this.detail).show();
			} else {
				var dd = $(this).parent();
        var ddiv = $('<div></div>').attr('style', 'padding:10px;margin:10px;background:white;border:1px solid #cccccc').appendTo(dd);
        var detailDiv = $('<textarea>' + detail + '</textarea>').attr('readonly', 'readonly').attr('style', 'background:transparent; height: 120px;width:100%;padding:0px;margin:0px; overflow: auto; font-size: 9pt;border:0px none').appendTo(ddiv);
        this.detail = ddiv[0];
			}
		};
		confirm.dialog({ width: 460, title: title, "buttons": buttons });
	},
	progressDialog: function (title) {
		var progress = $("<div></div>");
		var progressBar = $("<div></div>").addClass('progressBar').appendTo(progress);
		var progressText = $("<div></div>").appendTo(progress);

		var buttons = {};
		buttons[$.dictionary.getValue('cancelButton')] = function () { $(this).dialog('destroy'); };
		progress.dialog({ width: 460, title: title, "buttons": buttons });
		progressBar.progressbar();
		var progressDialogHelper = function (dialog, txtElement, barElement) {
			this.dialog = dialog;
			this.txtElement = txtElement;
			this.barElement = barElement;
			this.updateText = function (message) {
				this.txtElement.html(message);
			};
			this.close = function () {
				this.dialog.dialog('destroy');

			};
			this.updateValue = function (value) {
				this.barElement.progressbar('value', value);
			};
		};
		return new progressDialogHelper(progress, progressText, progressBar);
	},
	qFormDialogHelper: function (dialog, options) {
		var $this = this;
	    this.logMessage = '';
		$.data(dialog[0], "qformDialogHelper", $this);

		var $dialog = $(dialog);

		//claer the ajax cache
		$.ajaxSetup({ cache: false });

		//$form.bind('change', function() { alert('formchange'); });
		$this.settings = {};
	    var defaultfields = {};
	    var originaldata = {};
		var formId = null;
	  if ($this != null) {
	    $this.isDirty = '0';
	    $this.isNew = '1';
	    $this.isReadonly = '1';

	    if (options.id == undefined)
	      $this.isNew = '0';
	  }
	  var buttonsDirty = null;
		var defaultSettings = {

			resetMessage: "This report will be restored to its original state and all changes will be lost.<br />Are you sure you want to continue?",
			resetTitle: "Are you sure?",
			errorMessage: "The following errors must be fixed before you can save the report:",
			errorTitle: "Could not save eReport",
			getButtons: function () {
				if (!$this.isReadonly || $this.isReadonly == '0') {
					return { 'Submit': function () { $this.submitForm('submit'); }, 'Save as draft': function () { $this.submitForm('save'); } };
				} else {
					return { 'Close': function () { } };
				}
			},

			url: "/qform.aspx/qforms/submit"
		};

		this.addTab = function (id, tabName, url) {
		    $.get(url, function (html) {
		        
		        var tabs = $("#tabstrip").tabs();
		        var ul = tabs.find("ul.ui-tabs-nav");
		        $("<div id='tab-" + id + "'></div>").html(html).appendTo($("#tabstrip"));
		        
		        $("<li><a href='#tab-" + id + "'>" + tabName + "</a></li>").appendTo(ul);
		        tabs.tabs("refresh");
		    
		        
		       
		    });
		    

		};
    // { Text: "test", "Position": left", "Url":"","Class" }
    this.customButtons = [];
		this.addCustomFields = function () {
		    var buttons = $dialog.parent().find('.ui-dialog-buttonpane');
		    buttons.find('.qformCustomField').remove();
		    // Request Confidentiality
		    if ($this.showRequestConfidentiality) {
		        var field = $("<div class='ui-state-default qformCustomField'><input type='checkbox' disabled='disabled' id='chk_reqConfidentiality' /><label>" + $.dictionary.getValue("label_RequestConfidentiality") + "</label></div>");
		        
		        field.appendTo(buttons);
		        var existingValue = $dialog.parent().find("#requestConfidentialityHdn").val();
		        if ($this.isReadonly == '0')
		            field.find('input').removeAttr('disabled');
		        
		        if (existingValue == 'true' || (existingValue != 'false' && $this.requestConfidentialityValue == true)) {
		            field.find('input').attr('checked', 'checked');
		            $dialog.parent().find("#requestConfidentialityHdn").val("true");
		        }
		        field.find('input').change(function () {
		            var hdn = $dialog.parent().find("#requestConfidentialityHdn");
		            if ($(this).is(':checked'))
		                hdn.val("true");
		            else
		                hdn.val("false");
		        });
		    }
		};
    this.addCustomButtons = function () {
        
      var buttons = $dialog.parent().find('.ui-dialog-buttonpane');
      buttons.find('.qformbutton').remove();
      
      for (var i in $this.customButtons) {
        var customButton = this.customButtons[i];
        var btnclass = customButton.btnclass || "";
        var pos = customButton.position || "right";
        var onclick = customButton.onclick || null;
        var txt = customButton.text || "";
        var btn = $('<button type="button" style="float:' + pos + '" class="' + btnclass + ' qformbutton ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button" aria-disabled="false"><span class="ui-button-text">' + txt + '</span></button>');

        btn.appendTo(buttons);
        if (onclick != null)
          btn.click(onclick);
      }

    };
		/// ------------------------------------
		/// Add buttons to the form
		/// Checks the dirty flag and displays either "Save+Cancel" or "Submit+Close"
		/// ------------------------------------
		this.addButtons = function () {
			var dialogContainer = $dialog;
			var fdialog = $dialog.find(".ui-dialog-content");
			var buttons = $this.settings.getButtons($this);
			if ($this.buttonsDirty != $this.isDirty) {
				$dialog.dialog('option', 'buttons', buttons);
				$this.buttonsDirty = $this.isDirty;
			}
			
      $this.addCustomButtons();
      $this.addCustomFields();
      $dialog.trigger('qformButtonsUpdated');
		};
		$dialog.attr('data-qform-readonly', 'true');
        
		this.submitForm = function (submitType) {
		    $.showLoadingSpinner();
		    $(document).ready(function () {
		        $.showLoadingSpinner();
		});
			$('#submitType').val(submitType);
		
			$dialog.find('form').submit();
            
        };
		this.closeDialog = function () {
			// Unbind all events
      if ($dialog == null)
        return; // Already closed
		    $dialog.unbind('qformCustomButtonClicked');
			$dialog.find('form').unbind('submit');
      $dialog.trigger('closingQformDialog');

			$(document).unbind("post/" + $this.settings.url.replace(/\./g, '_').toLowerCase());
			$dialog.dialog('destroy');
      $dialog.find('form').remove();
		    $dialog.hide();
			// Clean up qformDialogHelper
			$dialog = null;
			$this.settings = null;
			$this = null;

			formId = null;
			originaldata = null;
			//this = null;
    };

	    this.initialLoad = function(json, skipReset) {

	        $this.loadFormData(json);
	        $(document).trigger('qformDataLoaded', $this);
	    };
		/// -------------------------------------
		/// Loads form data from JSON 
		/// -------------------------------------
		this.loadFormData = function (json, skipReset) {


			if (json["Actions"] && json["Actions"]["setDateOffset"]) { // Always process this action first
				dateSettings[json["Actions"]["setDateOffset"]["storedAs"] + "Adjustment"] = json["Actions"]["setDateOffset"]["offset"];
			}
			if (json["Actions"] && json["Actions"]["openUrl"]) { // Always process this action first
				var url = json["Actions"]["openUrl"]["url"];// ] = json["Actions"]["setDateOffset"]["offset"];
				window.open(url, '_blank');
			}

			if (json['Actions']) {
				for (var key in json['Actions']) {
          if (key != "setReadonly")
					processAction(key, json['Actions'][key], skipReset);
				}
      }
      if (json["Actions"] && json["Actions"]["setReadonly"]) { // Process setReadonly last
        processAction("setReadonly", json["Actions"]["setReadonly"]);
			}
      $(".ui-dialog input, .ui-dialog textarea").change(function () {
          
        if ($this != undefined && $this != null && $(this).attr('data-ignoredirty') != 'true') {
              
          $this.isDirty = '1';

          $this.addButtons();
        }
      });
      $(".ui-dialog input, .ui-dialog textarea").keypress(function () {
        if ($this != undefined && $this != null) {
              
          $this.isDirty = '1';
          $this.addButtons();
        }
      });
      $(document).bind('selectItem', function (ev, data) {

          if (data.canSetDirty == undefined || data.canSetDirty === true)
        if ($this != undefined && $this != null) {
            
				$this.isDirty = '1';
				$this.addButtons();
        }
			});
      $(document).bind('dirty', function () {
          
        if ($this != undefined && $this != null) {
              
          $this.isDirty = '1';
          
          $this.addButtons();
        }
      });
      $(document).bind('select', function () {
          return;
        if ($this != undefined && $this != null) {
              
          $this.isDirty = '1';

          $this.addButtons();
        }
      });
			// We should have originaldata now
      if (json["Actions"]["updateFields"] && (skipReset == undefined || skipReset == false)) {

          originaldata = json["Actions"]["updateFields"];


		} else if (json["Actions"]["defaultFields"] && (skipReset == undefined || skipReset == false)) {

		        defaultfields = json["Actions"]["defaultFields"];


		    }
		    if ($this != undefined && $this != null && json["Actions"]["error"] == undefined) {
			    
				$this.isDirty = '0';
				$this.formId = originaldata['qform.id'];

				$this.addButtons();
                $this.addCustomButtons();
            }
			//remove the processign block
		    $.hideLoadingSpinner();
			$(document).trigger('loadedQformData', json);
		}

		/// --------------------------------------------
		/// Resets form data
		/// --------------------------------------------
		this.resetData = function (json) {
		    
      processAction('updateFields', json, true);
			if ($this != null) {
				$this.isDirty = '0';

				$this.addButtons();
			}
			$dialog.find('form').validate().resetForm();
		}

		/// -----------------------------------
		/// User has clicked reset form button
		/// -----------------------------------
		this.resetForm = function () {
			var message = $this.settings["resetMessage"];
			$.confirmDialog(message, $this.settings["resetTitle"], function () {
        $(".ui-dialog input[type=text]").not('[name="FormID"]').not('[name="qform.formId"]').not('[name="qform.id"]').val("");
        $('.ui-dialog .mcdropdown input[type=hidden]').each(function () {
            $(this).mcDropdown().setValue('');
        });
			    $('.ui-dialog .mcdropdown.lookup').each(function() {
			        $(this).find('input').val('');
			        var id = $(this).attr('id');
			        $(this).parent().parent().find('input[linkedto=' + id + ']').val('');
			    });
			
				$(".ui-dialog textarea").val("");
				$(".ui-dialog select option").remove();
				$this.resetData(defaultfields);
				$this.resetData(originaldata);
			});

		}

		/// ---------------------------
		/// Converts the original JSON data into the format required by jmsajax
		/// ---------------------------
		function convertJSON(data) {

			var jsond = {};
			for (var key in data) {
				var value = data[key];
				if (value && value != null) {
					var el = $(document.getElementById(key));

					// Check for DATE TIME and convert it!
					if (el.attr('datatype') == 'Date' || (typeof value == 'object' && value != null)) {
						if (typeof value == 'string' && value != "") {
							value = Date.parseISO(value) || new Date(value);
						}
						if (typeof value == 'string' && value != "") {
							value = Date.parseISO(value) || new Date(value);
							if (isNaN(value.getTime()))
								value = $.datepicker.parseDate(value, el.datepicker('option', 'dateFormat'));
							var format = el.datepicker('option', 'dateFormat') || el.attr('format');

							if (typeof format == 'string') {
								value = $.datepicker.parseDate(null, el.datepicker('option', 'dateFormat'), value);
							} else {
								value = el.getDateValue();
							}
						}
						jsond[key + ".original"] = el.formatDate('yyyy-mm-ddTHH:II:00', value);
					} else {
						jsond[key + ".original"] = value;
					}
				}
			}

			return jsond;
		}


		/// ---------------------------
		/// Converts the serialized Form JSON data into the format required by jmsajax
		/// ---------------------------
		function convertJSONFromSerializedForm(data) {

			var jsond = {};
			for (var key in data) {
				var value = data[key];
				if (value && value['value'] != undefined && value['name']) {
					var el = $(document.getElementById(value['name']));


					if (value['value'] == '' && (originaldata[value['name']] == undefined || originaldata[value['name']] == ''))
						continue;
					// Check for DATE TIME and convert it!
					if (el.attr('datatype') == 'Date') {

						if (el.attr('FieldID') == '22') {

              jsond[value['name']] = el.formatDate('yyyy-mm-ddTHH:II:00', convertToStore(el.getDateValue(), $('input[FieldID="23"]').parent().find('input[type=hidden]').val()));
						} else {
							// May not be a date! Parse a time
							var dateRegex = /([0-9]{2}):([0-9]{2})/;
							var dValue = el.getDateValue() || el.val();
							var format = el.attr('format');
							if (format == "hh:nn") {
								var m = dateRegex.exec(dValue);
								dValue = new Date();
								dValue.setHours(m[1]);
								dValue.setMinutes(m[2]);
							}
							if (dValue != null && dValue != '')
								jsond[value['name']] = el.formatDate('yyyy-mm-ddTHH:II:00', dValue);
							else
								jsond[value['name']] = '';
						}
					} else {
						jsond[value['name']] = value['value'];
					}
				}
			}

			return jsond;
		}

		function processAction(name, action, skipReset) {
		    if (skipReset == undefined)
		        skipReset = false;
        if (name == 'error') {
          // Show error dialog
          var errors = $this.settings.errorMessage;
          for (var key in action) {
            errors = errors + '<br />' + action[key];
          }
          var errorDialog = $.errorDialogModal(errors, $this.settings.errorTitle);

        }
        if (name == 'errorGeneric') {
          // Show error dialog
          var errors = "";
          for (var key in action) {
            errors = errors + action[key] + '<br />';
          }
          var errorDialog = $.errorDialog(errors);

        }
			if (name == 'addtab') {
			    
			    $this.addTab(action['id'], action['text'], action['url']);
			}
			if (name == 'event') {

				for (var key in action) {


					if ($.event.global["js/" + key]) {
						$.event.trigger("js/" + key, action[key]);
					}
					if ($.event.global["any/" + key]) {
						$.event.trigger("any/" + key, action[key]);

					}

				}
			}
			if (name == 'showCustomDialog') {
			    var dialog = $.genericDialog({
                    dialogUrl: action['DialogUrl'],
                    okButtonLabel: 'Save',
                    width: action['Width'],
                    height: action['Height'],
			        title: action['Title'],
			        callback: function () {
			            dialog.dialogDiv.trigger('saveDialog', { qform: $this, dialog: dialog });
			        }
			    });

			}
			if (name == 'info') {
				// Show error dialog
				var info = '';
				for (var key in action) {
					info = info + action[key] + '<br />';
				}
                if (info != null && info != '')
				    $.infoDialogModal(info, "");
			}
			if (name == 'warning') {
			    // Show error dialog
			    var info = '';
			    for (var key in action) {
			        info = info + action[key] + '<br />';
			    }
			    if (info != null && info != '')
			        $.confirmDialogModal(info, "",function() {
			            $this.submitFormHandler(null, { source: $dialog.find('form') }, { resubmitKey: key });
			        }, function() {});
			}
			if (name == "requestConfidentiality") {
			    $this.showRequestConfidentiality = true;
			    $this.requestConfidentialityValue = action['value'];
			}
              if (name == 'occTypes') {

                var currentFormId = $.query($dialog.attr('ajaxurl')).formId;
                for (var i in action) {
                    
                  $this.customButtons.push({
                    text: i,
                    btnclass: currentFormId == action[i].Key || action[i].Value === false ? " ui-state-disabled " : "",
                    position: 'left',
                    onclick: currentFormId == action[i].Key || action[i].Value === false ? null : (function (occtype, form) {
                      return function () {
                        $dialog.trigger('occTypeClicked', { occtype: occtype, form: form });
                      };
                    })(i, action[i])
                  });
                }


              }
			if (name == 'customButtons') {

			    var currentFormId = $.query($dialog.attr('ajaxurl')).formId;
			    for (var i in action) {

			        $this.customButtons.push({
			            text: i,
			            position: 'right',
			            onclick: (function (buttonName, buttonId) {
			                return function () {
			                    $dialog.trigger('qformCustomButtonClicked', { text: buttonName, id: buttonId });
			                };
			            })(i, action[i])
			        });
			    }
      }
			if (name == 'closeForm') {
				// Close the dialog
				//$dialog.dialog('destroy');
				//Must unattach bindings and clean up so call function
				$this.closeDialog();
			}
			if (name == 'unsetReadonly') {
			    // Allow the department to be changed
			    $dialog.removeAttr('data-qform-readonly');
				// Unset readonly
				$this.isReadonly = '0';
			    $('#chk_reqConfidentiality').removeAttr('disabled');
        $dialog.find('.mcdropContainer').removeAttr('data-disabled');
        $dialog.find('button.eventButton,input.eventButton,.eventButton,input[type="text"],input[type="radio"],input[type="hidden"],input[type="checkbox"],textarea,div').removeAttr('disabled').removeAttr('readonly').each(function () {
            $dialog.find('button.eventButton,input.eventButton,.eventButton').trigger('buttonEnabled');          if ($(this).parent().is('.mcdropdown') && $(this).is('input[type=hidden]')) {
            $(this).mcDropdown().disable(false);
          }
          $(this).removeAttr('disabled');
          $(this).removeAttr('readonly');
          $(this).triggerHandler('enabled');
        });

				$this.addButtons();

			}
			if (name == 'setReadonly') {
        
				// Close the dialog
				for (var key in action) {
					var field = $(document.getElementById(key));
          
					if (field != null) {
            field.attr('disabled', 'disabled').triggerHandler('disabled');
					}
				}

			}

			if (name == 'highlightFields') {

			    // Close the dialog
			    for (var key in action) {
			        var field = $(document.getElementById(key));

			        if (field != null) {
			            var linkedEl = $(field).attr('linkedto');
			            if (linkedEl != undefined && linkedEl != null && linkedEl != '')
			                field = $(document.getElementById(linkedEl));
			            if ($(field).parent().is(".mcdropdown"))
			                field = $(field).parent();
			            field.addClass('required').trigger('highlightField');
			        }
			    }

			}

			if (name == 'highlightErrors') {

			    // Close the dialog
			    for (var key in action) {
			        var field = $(document.getElementById(key));

			        if (field != null) {
			            var linkedEl = $(field).attr('linkedto');
			            if (linkedEl != undefined && linkedEl != null && linkedEl != '')
			                field = $(document.getElementById(linkedEl));
			            if ($(field).parent().is(".mcdropdown"))
			                field = $(field).parent();
			            field.addClass('error field-validation-error').trigger('error');
			        }
			    }

			}
			if (name == 'form') {

				// Close the dialog
				$(document).unbind("post/" + $this.settings.url.replace(/\./g, '_').toLowerCase());
				$dialog.find('form').attr('action', action["action"]);

				$this.settings.url = action["action"];
				$(document).bind("post/" + $this.settings.url.replace(/\./g, '_').toLowerCase(), $this.submitFormHandler);

			}
			if (name == 'updateFields' || name == 'defaultFields') {
			    
                if (name != 'defaultFields')
                if (skipReset == undefined || skipReset == false) {
                    $(".qformDialogPanel input").not('[type="checkbox"]').not('[type="hidden"]').not('[type="radio"]').not('[type="button"]').not('[type="submit"]').not('[name="FormID"]').not('[name="qform.formId"]').not('[name="qform.id"]').val("");
            
                    $(".qformDialogPanel textarea").val("");
                    $(".qformDialogPanel select option").remove();
                    if (originaldata != null)
                    $this.resetData(originaldata);
                }
        
                if (originaldata != null && (skipReset == undefined || skipReset == false))
                    for (var i in originaldata) {
                    if (action[i] == undefined)
                        action[i] = null;
                    }

                dateSettings['disabled'] = true;
			  if ($this == null)
			    return;
				for (var key in action) {
				    
					if (key == "qform.id" && action[key] != 0) {
					  if ($this != null) {
					    $this.isNew = 0;
					  }
					}

					// if null check added by BEK Matt to tidy
					if (document.getElementById(key) != null) {

					    var field = $(document.getElementById(key));
					    
						if (action[key + "_input"] != undefined) 
						    field.attr('data-input-val',action[key + "_input"]);

						var value = action[key];

						try {


							// special case: handle checkboxes

							if (document.getElementById(key + "_chk") != null) {

								if ((value != null && value === true) || value == $(document.getElementById(key + "_chk")).attr('value')) {
									field.val(-1);

									$(document.getElementById(key + "_chk")).attr('checked', true);
								} else {
									field.val(0);

									$(document.getElementById(key + "_chk")).attr('checked', false);
								}
							} else if (field.attr('DataType') == 'Date') {
								if (typeof value == 'string' && value != "") {
                  if (value == '0001-01-01T00:00:00') {
                    value = '';

                  } else {
                    value = Date.parseISO(value) || new Date(value);
                  }
								}

                if (typeof value == "string" && value.indexOf("/Date") == 0) {
                  var r = /\/Date\(([0-9]*)\)\//;

                  value = new Date(parseInt(r.exec(value)[1]));

                }
								if (typeof value == "object" && value != null)
									value = Date.parseISO(value) || new Date(value);
								
								// Might not be a datepicker
								if (field.is('.hasDatepicker') || field.is('.flatpickr-input')) {

								    field.setDateValue(value);
										if ( field.attr('fieldid') == "22") {
											var occurrenceutcfield = $('input[fieldId=23]');
												if (occurrenceutcfield.length == 0)
														occurrenceutcfield = $('div[fieldId=23] >*:first');
												if (occurrenceutcfield.length == 0)
														occurrenceutcfield = $('div[fieldId=23] >*:first');

												if (occurrenceutcfield.length != 0)
													field.setDateValue(convertDate(value,'UTC',occurrenceutcfield.val())) 
										}
								} else {

									// May not be a date! Parse a time
									var format = field.attr('format');
									if (format == "hh:nn") {

										field.val(value.format('HH:mm'));
									}
								}
							} else if ($(document.getElementById(key + "_field")).parent().is('.mcdropdown') && !field.parent().is('.lookup')) {
							    
							    $(document.getElementById(key + "_field")).attr('update-value', 'true');
                
                  $(document.getElementById(key + "_field")).mcDropdown().setValue(value);
                  $(document.getElementById(key + "_field")).removeAttr('update-value');
							    
                
							} else {
							    
								if (value == null) {

                    field.trigger('setValue', '');
										field.val('');
                  
								} else {

                    field.trigger('setValue', value);
										field.val(value);
                  
								}
							}


							field.trigger('change');
						} catch (err) {
						
							var dpError = $.dictionary.getValue('errorUpdatingField');
							// Not supposed to be showing these dialogs - Still not working properly.
							//	$.errorDetailDialog(dpError, $.dictionary.getValue('error'), $.formatJavascriptErrorDetail(err.message, err.fileName, err.lineNumber, err.stack), $.closeEreportDialog);
						}
					}
					dateSettings['disabled'] = false;
				}
			}
        $(document).ready(function() {
            $(document).trigger('loadedQformData', {});
           
            $.hideLoadingSpinner();


        });
    }


		$.extend($this.settings, defaultSettings);
		$.extend($this.settings, options);

		// Because the QFormBuilder does not have access to the fieldReportID, we have to handle the file-selection->upload
		// process here instead.
		// I've basically copied the JS produced by the FileInputElement.UploadImmediately() extension method

		$dialog.find('input[type="file"]').bind('fileselected', function (ev,data) {
			var helper = $(this).uploadHelper();
			var url = $this.settings.uploadUrl;
			if (url == undefined || url == null)
				url = $this.settings.url;

			helper.upload(url, data);

		});
		$this.sendQFormEvent = function (handlerUrl, eventName, callback) {
		    
	        var data = $this.getQFormData();
          var url = $.buildUrl(handlerUrl, { eventType: eventName });
		  $.showLoadingSpinner();
      $.postJSON(url, { qformData: data }, function (res) {
        $.hideLoadingSpinner();
	            if (res === false || !res["Actions"])
	                return;
	            var newKeys = {};
                for (var key in res['Actions']['updateFields']) {

                    newKeys["qform." + key] = res['Actions']['updateFields'][key];

	                var element = $('input[id="qform.' + key + '"]');

                    // Need to change disabled fields to readonly
	                if (element.length > 0 && element.is(':disabled'))
	                    element.removeAttr('disabled').attr('readonly', 'readonly');
                }
                
                res['Actions']['updateFields'] = newKeys;
	            if (res["Actions"]["info"] != undefined && res["Actions"]["info"]["success"] != undefined)
	                $this.logMessage += res['Actions']['info']['success'] + "\n";
	            $this.loadFormData(res, true);
	            $(document).trigger('dirty');

	            if (callback !== undefined) {
	                callback(res);
	            }
	        });
	    };
	    $this.getQFormData = function () {

	        var data = convertJSONFromSerializedForm($dialog.find('form').serializeArray());
	        var formObj = {};
	        var jsonObj = {};
	        for (var origkey in data) {
	            if (origkey.indexOf('qform.') >= 0 && parseInt(origkey.replace('qform.', '')) !== NaN) {
	                var key = origkey.replace('qform.', '').toLowerCase();
	                var subkey = "";
	                if (key.indexOf('_') > 0) {
	                    var keyParts = key.split('_');
	                    key = keyParts[0];
	                    subkey = keyParts[1];
	                }
	                if (jsonObj[key] == undefined)
	                    jsonObj[key] = {};
	                jsonObj[key].ID = key;
	                if (subkey != '') {
	                    jsonObj[key][subkey] = data[origkey];
	                } else {
	                    jsonObj[key].value = data[origkey];
	                }
	            } else {
	                formObj[origkey] = data[origkey];
	            }
	        }
	       // window.jjj = jsonObj;
	        formObj.fields = Object.keys(jsonObj).map(function (v) { return jsonObj[v]; });
	        if (jsonObj["id"] != undefined && jsonObj["id"].value != undefined)
	            formObj.ID = jsonObj["id"].value;
            
	        //window.formObj = formObj;
	        return formObj;
	    };
		$this.submitFormHandler = function (evt, eventData, customData) {

			// DO MSAJAX POST
			var data = {};

			$.extend(data, convertJSONFromSerializedForm($(eventData.source).serializeArray()));
			$.extend(data, convertJSON(originaldata));
		    if (customData !== undefined)
		        $.extend(data, customData);
		    data['logMessage'] = $this.logMessage;
      $.post($this.settings.url, data, function (d) {

				$this.loadFormData(d);

			});
			return false;
		};
		/// Bind to SubmitForm event of Ereport/QForms
		/// Submits the form via AJAX, and inserts the original JSON data into the request being sent back to the server

		$(document).bind("post/" + $this.settings.url.replace(/\./g, '_').toLowerCase(), $this.submitFormHandler);



		/// Bindto TabsCreated event (fired by jquery Tabs.js)
		/// Automatically resize the dialog if tabs are too wide/high

		$(document).bind('js//tabs/created', function (evt, eventData) {

			$('.ui-dialog').width($('.ui-dialog-content').outerWidth());
			var h = 0;
			$('.ui-dialog-content').find('*').each(function () {
				var newh = $(this).position().top + $(this).outerHeight();
				if (newh > h) {
					h = newh;
				}
			});

			var fullheight = $('.ui-dialog-content').next().outerHeight() + $('.ui-dialog-content').prev().outerHeight() + h;
			$('.ui-dialog-content').height(h);
			$('.ui-dialog').height(fullheight + 12);


		});

		$dialog.find('form').bind("invalid-form.saveButton", function () {
			var errorMessages = "";

			var validator = $.data($dialog.find('form').get(0), 'validator');
			for (var err in validator.errorList) {
        $(validator.errorList[0].element).addClass('field-validation-error');

				errorMessages = errorMessages + validator.errorList[err].message + "<br />";
			}

			if (validator.errorList.length > 0) {
				var text = $this.settings.errorMessage + "<br />" + errorMessages;
        var dialog = $.errorDialogModal(text, "Validation failed", function () {
            $(validator.errorList[0].element).parents('.ui-tabs').tabs('option','active', $(validator.errorList[0].element).parents('.ui-tabs-panel').index('.tab'));
            $(validator.errorList[0].element).parents('.ui-collapsible').children("h3").children().children().children(".ui-icon-triangle-2-s").trigger("click");
            console.log("Focusing......");
					$(validator.errorList[0].element).focus();
					$(this).remove();
				});
        

			}
			$(document).ready(function () {

			    $.hideLoadingSpinner();
			})
		});


	}
});

